module.exports = __webpack_public_path__ + "img/合同签订.e553a9e0.png";